<div class="flex flex-col w-full">
    <!-- Hero Banner -->
    <div class="w-full bg-cover bg-center py-32 text-center"
        [ngStyle]="{ 'background-image': 'url(' + campaignInfo?.headerImage?.url + ')' }">
        <h1 class="text-white font-bold text-4xl md:text-6xl">
            {{ campaignInfo?.Title || 'Win With Us' }}
        </h1>
    </div>

    <!-- Content Section -->
    <div class="w-full  flex justify-center py-16 px-4">
        <div
            class="bg-primary-50  rounded-3xl shadow-lg flex flex-col lg:flex-row w-full max-w-6xl overflow-hidden p-6 lg:p-12 gap-8">
            <!-- Left Card -->
            <div
                class="bg-primary text-white rounded-3xl p-8 lg:w-1/2 flex flex-col justify-center items-center text-center">
                <img *ngIf="campaignInfo?.bodyImage?.url" [src]="campaignInfo.bodyImage.url" alt="Logo"
                    class="h-16 w-auto" />
                <h1 class="text-4xl text-white" [innerHtml]="campaignInfo.bodyTitle | innerHTMLPipe"></h1>
                <p class="font-bold text-white" [innerHtml]="campaignInfo.bodyText | innerHTMLPipe"></p>
            </div>

            <!-- Right Form -->
            <div class="lg:w-1/2 w-full">
                <form [formGroup]="accountForm" class="space-y-4">
                    <h2 class="text-3xl font-bold mb-4">Confirm your personal information</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <mat-form-field appearance="fill">
                            <mat-label>First Name*</mat-label>
                            <input matInput [formControlName]="'name'" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Last Name*</mat-label>
                            <input matInput [formControlName]="'surname'" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Email Address*</mat-label>
                            <input matInput [formControlName]="'email'" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="fill">
                            <mat-label>Cellphone Number*</mat-label>
                            <input matInput [formControlName]="'phoneNumber'" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="md:col-span-2 readonly-matinput">
                            <mat-label>ID Number</mat-label>
                            <input matInput [formControlName]="'idNumber'" readonly />
                        </mat-form-field>

                        <mat-form-field appearance="fill" class="md:col-span-2">
                            <mat-label>Physical Address</mat-label>
                            <input matInput [formControlName]="'address'" readonly />
                        </mat-form-field>
                    </div>
                    <div class="flex flex-row space-x-2 justify-end">
                        <div class="flex justify-end mt-4">
                            <button
                                class="bg-primary text-white font-semibold py-2 px-6 rounded-full transition"
                                (click)="saveCustomerDetails()" *ngIf="this.accountForm.value.idNumber">
                                My details are correct
                            </button>
                        </div>
                        <div class="flex justify-end mt-4">
                            <button
                                class="bg-accent text-black font-semibold py-2 px-6 rounded-full transition"
                                (click)="update()">
                                Update my details
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<ng-template #createTicketDialog>
    <div class="border-b-2 pb-5">
        <h1 class="text-2xl pb-5 font-bold"> {{isRelocate ? 'Relocate Service' : 'Log a Ticket'}}</h1>
        <h3 *ngIf="!isRelocate">Please explain your issue in as much detail as possible, our team will strive to get
            to you
            soonest!</h3>
        <h3 *ngIf="isRelocate">Please note that the relocation is subject to Fibre availability at your new address.
            We will verify availability and guide you through the process.</h3>
    </div>
    <div class="pt-10">
        <form *ngIf="ticketForm" [formGroup]="ticketForm">
            <!-- Ticket Subject -->
            <mat-form-field class="w-full">
                <mat-label>Subject:</mat-label>
                <input matInput required formControlName="Subject" placeholder="Ticket Subject" [readonly]="isRelocate">
                <mat-error *ngIf="ticketForm.get('Subject').hasError('required')" class="text-warn text-md"> Please
                    enter a subject.</mat-error>
            </mat-form-field>

            <!-- Ticket Topic -->
            <mat-form-field class="w-full">
                <mat-label>Topic:</mat-label>
                <input matInput required formControlName="Topic" placeholder="Ticket Topic">
            </mat-form-field>

            <!-- Ticket Description -->
            <mat-form-field class="w-full">
                <mat-label>Description:</mat-label>
                <textarea matInput required formControlName="Description" [readonly]="isRelocate"
                    placeholder="Ticket Description"></textarea>
                <mat-error *ngIf="ticketForm.get('Description').hasError('required')" class="text-warn text-md">
                    Please enter a description.</mat-error>
            </mat-form-field>

            <div class="flex justify-end mt-4 space-x-4">
                 <button class=" text-white font-semibold py-2 px-6 rounded-full transition bg-primary"
                        (click)="this.createTicketDialogRef.close()">
                        Cancel
                </button>
                <button *ngIf="!loading" [disabled]="ticketForm.invalid" (click)="submitTicket()"
                  class="bg-accent  text-black font-semibold py-2 px-6 rounded-full transition" mat-flat-button [color]="'primary'">
                    Submit
                </button>
            </div>
        </form>
    </div>
</ng-template>






<ng-template #completionTemplate>
       <div class="bg-white rounded-3xl   w-full     relative" (click)="$event.stopPropagation()">
            <h2 class="text-3xl font-bold mb-6">Update your information</h2>
            <form [formGroup]="accountForm" class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <mat-form-field appearance="fill">
                        <mat-label>First Name*</mat-label>
                        <input matInput [formControlName]="'name'" />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Last Name*</mat-label>
                        <input matInput [formControlName]="'surname'" />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Email Address*</mat-label>
                        <input matInput [formControlName]="'email'" />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Cellphone Number*</mat-label>
                        <input matInput [formControlName]="'phoneNumber'" />
                    </mat-form-field>
                    <mat-form-field appearance="fill" class="md:col-span-2 readonly-matinput">
                        <mat-label>ID Number</mat-label>
                        <input matInput [formControlName]="'idNumber'" readonly />
                    </mat-form-field>
                    <div class="flex flex-row md:col-span-2 space-x-1 -mt-2 mb-2">
                        <p class="text-sm text-gray-600 m-0">
                            Is your ID number wrong?
                        </p>
                        <a (click)="openTicketModal(createTicketDialog)"
                            class="text-sm text-primary font-semibold cursor-pointer m-0">
                            Click here
                        </a>
                    </div>
                    <mat-form-field appearance="fill" class="md:col-span-2">
                        <mat-label>Physical Address</mat-label>
                        <input matInput type="text" #addressInput [formControlName]="'address'"
                            (focus)="initAutocomplete(addressInput)" autocomplete="off" />
                    </mat-form-field>
                </div>
                <div class="flex justify-end mt-4 space-x-4">
                    <button
                        class="text-white font-semibold py-2 px-6 rounded-full transition  bg-primary"
                        (click)="this.completionTemplateRef.close()">
                        Cancel
                    </button>
                    <button
                        class="bg-accent text-black font-semibold py-2 px-6 rounded-full transition"
                        (click)="saveCustomerDetails()">
                        Enter competition
                    </button>
                </div>
            </form>
        </div>
</ng-template>




 